const pt = {
	dyn_wallet_details_card: {
		header: "Detalhes da Wallet",
		address: "Endereço",
		copy: "Copiar",
		copied: "Copiado!",
	},
	dyn_active_wallet_info: {
		testnet_warning: "Uma rede de teste foi selecionada. Por favor, use apenas fundos de teste ou eles serão perdidos.",
		ordinals_address: "Endereço Ordinals",
		payment_address: "Endereço de pagamento",
		balance: "Saldo total",
		options: {
			copy_ens: "Copiar ENS",
			view_address: "Ver endereço",
			disconnect: "Desconectar",
			settings: "Configurações da carteira",
			export: "Exportar chaves privadas",
		},
	},
	dyn_captcha: {
		verify_user_subtitle: "Precisamos verificar rapidamente que você é humano antes de prosseguirmos.",
		verify_user_title: "Vamos verificar se você é humano",
	},
	dyn_access_blocked: {
		title: "Acesso Bloqueado",
		content: "O login não está disponível para pessoas em {{jurisdiction}} como você está em uma jurisdição sancionada.",
	},
	dyn_chainalysis_blocked_wallet: {
		title: "Acesso negado",
	},
	dyn_login: {
		connect_wallet: {
			title: "Conectar",
		},
		email_form: {
			email_field: {
				label: "Digite seu email",
			},
			submit_button: {
				label: "Continuar",
			},
		},
		email_or_phone: {
			use_email: "Usar email",
			use_phone: "Usar telefone",
			prefer_email: "Preferir cadastro com email?",
			prefer_phone: "Preferir cadastro com telefone?",
		},
		helper: {
			all_wallet_list: "Obter sua primeira carteira",
			email_form: {
				invalid_email: "Email inválido ou incorreto. Você digitou errado?",
			},
			pending_connect: {
				title: "Conectando uma carteira",
			},
			pending_signature: {
				title: "Assinando uma carteira",
			},
			pending_signature_without_back_button: {
				title: "Assinando uma carteira",
			},
			phone_number_form: {
				invalid_phone: "Número inválido ou incorreto. Você digitou errado?",
				invalid_sms_verification: "O código que você digitou está incorreto. Por favor, tente novamente.",
				too_many_sms_verification_attempts: "Muitas tentativas de verificação, por favor, tente novamente mais tarde.",
			},
			qr_code: {
				title: "Conectando uma carteira",
			},
			wallet_only: "Obter sua primeira carteira",
		},
		qr_code: {
			title: "Conectar",
		},
		separators: {
			default: "OU",
		},
		sign_wallet: {
			title: "Assinar",
		},
		select_wallet_in_wallet_group: {
			title: "Selecionar",
		},
		social: {
			button_label: "Continuar com {{provider}}",
			overlay_title: "Escolha uma conta social",
		},
		title: {
			all: "Log in ou cadastre-se",
			all_wallet_list: "Selecione sua carteira",
			wallet_only: "Selecione sua carteira",
		},
		wallet_group: {
			title: "Selecionar Rede",
		},
		wallet_list: {
			button_only: "Continuar com uma carteira",
		},
		mobile_wallet_redirect: {
			backup_title: "Conectar aplicativo móvel",
			prompt: "Toque em 'Abrir' para continuar",
			get_app_prompt: "Obter",
			open_prompt: "Abrir",
			redirect_fail_message: "Se o aplicativo não abrir, você pode precisar baixar o aplicativo da carteira {{walletName}}.",
			app_store: "App Store",
			play_store: "Play Store",
		},
		wrong_social_account: {
			retry_button: "Tente novamente",
			retry_title: "Por favor, conecte com: ",
			subtitle: "Você deve conectar com a mesma conta que você originalmente se inscreveu.",
			title: "Whoops. Conta errada",
		},
	},
	dyn_settings: {
		global_connectivity_section: {
			title: "Conectividade Global",
			connected_apps_button: "Aplicativos Conectados",
		},
		export_section: {
			private_key_button: "Chave Privada",
			srp_button: "Frase de Recuperação",
			title: "Exportar & Backup",
		},
		identity_section: {
			title: "Recuperação",
			add_email_button: "Adicionar email",
		},
		tags: { recommended: "Recomendado" },
		security_section: {
			email_auth_button: "Código de um só uso",
			passkey_button: "Passkeys",
			password_button: "Passcode",
			mfa_button: "App autenticadora",
			title: "2 factor authentication",
		},
		title: "Configurações",
		button_logout: "Sair",
		account_security: {
			title: "Conta & Segurança",
		},
		empty_screen: {
			title: "Nada para ver aqui ainda!",
		},
	},
	dyn_need_help_section: {
		info: "Precisa de Ajuda?",
		contact_support: "Contate o suporte",
		divider: "ou",
		help_button: "Ir para o suporte",
		visit_platform: "Visite {{platform}}",
	},
	dyn_no_access: {
		chainalysis: {
			button_text: "Tente outro método",
			description: "Esta carteira foi correlacionada a atividades ilícitas e não pode acessar este site.",
			social_media_link_text: "Por que estou vendo esta mensagem?",
			social_media_link_url: "https://docs.dynamic.xyz/docs",
			title: "Este endereço parece corrompido.",
		},
		default: {
			button_text: "Tente outro método",
			description: "Você não está atualmente na lista de permissões.",
			title: "Acesso negado",
		},
		gate: {
			button_text: "Tente outra carteira",
			description: "Uma NFT ou um token é necessário para acessar este site.",
			title: "Você não pode acessar o site",
		},
		not_in_the_list_image_alt: "user is not in the list",
		title: "Você não tem acesso",
	},
	dyn_pending_connection: {
		title: "Conectar",
		mobile: "Clique em conectar na sua carteira móvel",
		computer: "Clique em conectar na sua carteira popup",
	},
	dyn_pending_signature: {
		click_to_sign: "Clique para assinar",
		note: "Nota: ",
		phantom_ledger_sign: "Clique em assinar na sua carteira para confirmar que você possui esta carteira (isso não custa gas).",
		phantom_ledger_warning: "Ledger não suporta assinatura de mensagens. Quando você faz login, uma pequena taxa (que não deveria se aplicar) pode aparecer. Veja abaixo para mais informações.",
		regular_sign_description: "Clique em assinar na sua carteira para confirmar que você possui esta carteira.",
	},
	dyn_qr_code: {
		copy_button: "Copiar QR URI",
		get_extension_button: "Obter Extensão",
		open_button: "Abrir Aplicativo",
		scan_title: "Escaneie este código QR da sua carteira móvel {{app}} ou da câmera do seu telefone para conectar.",
		wallet_not_installed: {
			browser_install: "Instalar extensão {{browser}}",
			install: "Instalar extensão {{wallet}} para conectar",
			refresh: "Atualize a página uma vez instalada",
			select: "Selecione das opções abaixo:",
		},
	},
	dyn_wallet_locked: {
		connect_continue: "Conecte sua carteira para continuar",
		title: "Bem-vindo de volta",
		subtitle: "Não pudemos conectar à sua carteira. Clique em conectar para tentar reconectar",
		connect: "Conectar carteira",
		logout: "Sair",
	},
	dyn_select_chain: {
		description: "Esta carteira suporta várias redes. Selecione a rede que você deseja conectar",
		using_hardware_wallet_toggle_label: "Usando Ledger",
	},
	dyn_select_wallet: {
		description: "Selecione sua carteira preferida {{walletName}}?",
	},
	dyn_sign_message: {
		cancel_button: "Cancelar",
		sign_button: "Assinar",
		title: "Solicitando Assinatura",
	},
	dyn_wallet_redirect: {
		loading: "Carregando...",
	},
	dyn_wallet_conect: {
		mobile: {
			wallet_list: {
				helper: "Obter sua primeira carteira",
				title: "Carteiras WalletConnect",
			},
		},
	},
	dyn_wallet_list: {
		configuration_mismatch: "Oops, nenhuma forma de login foi configurada.",
		helper: "Obter sua primeira carteira",
		search: {
			label: "Pesquisar por {{numberOfWallets}} carteiras...",
			not_found: {
				description: "A carteira que você está procurando pode não estar disponível, ou vincular mais de uma dessas carteiras pode não ser possível.",
				title: "Carteira não disponível",
			},
		},
		title: {
			connect: "Conectar uma nova carteira",
			link: "Vincular uma nova carteira",
			select: "Selecione sua carteira",
		},
		view_all: "Ver todas as carteiras",
		wallet_missing: {
			description: "Tente buscar em outro lugar",
			title: "Não veja sua carteira?",
		},
	},
	dyn_wallet_link: {
		cannot_link: {
			cancel_button: "Cancelar",
			description: "Esta carteira é a única carteira em sua outra conta. Você não pode transferir, pois isso significa perder acesso a essa conta.",
			link_other_button: "Vincular uma carteira diferente",
			title: "Não é possível vincular esta carteira a uma nova conta",
		},
		confirm_button: "Vincular carteira à conta atual",
		existent_account: {
			acceptance: "Entendo que vincular esta carteira significa que perderá acesso à outra conta.",
			warning: "Vincular sua carteira a esta conta desvinculará sua carteira da conta anteriormente associada",
		},
		log_out_button: "Sair",
		title: "Transferir esta carteira?",
		already_exists: {
			title: "Carteira já vinculada",
			description: "Esta carteira já está usada como carteira incrustada. Você não pode vinculá-la a menos que exclua a carteira incrustada existente.",
		},
	},
	dyn_widget: {
		connect: "Log in ou cadastre-se",
		empty_wallets: "{{action}} mais carteiras para ver aqui.",
		other_wallets: "Minhas outras carteiras",
		empty_wallets_action_link: "Vincular",
		empty_wallets_action_connect: "Conectar",
	},
	dyn_wallet_information: {
		balance: "Saldo",
		multi_asset: {
			empty_state: "Nenhum ativo nesta carteira",
		},
	},
	dyn_user_profile: {
		my_information: {
			title: "Minhas informações",
		},
		my_wallet: {
			title: "Minha carteira",
		},
		social_accounts: {
			title: "Contas sociais",
		},
		tooltips: {
			verified_email: "Este email está verificado",
			verified_phone: "Este número de telefone está verificado",
		},
		wallets: {
			link_wallet_button: "Vincular carteira",
			title: "Quer adicionar uma carteira?",
		},
		edit_profile_button: "Editar perfil",
	},
	dyn_detected_new_wallet: {
		title: "Alteração de conta detectada",
		description: "Sua conta ativa em {{walletName}} foi alterada. Esta conta não está atualmente vinculada a este aplicativo. Você deseja adicioná-la?",
		confirm_button: "Sim, vincular esta carteira",
	},
	dyn_widget_header: {
		buttons: {
			deposit_funds: "Depositar",
			send_funds: "Enviar",
			more: "Mais",
		},
	},
	dyn_error: {
		default: "Algo saiu errado. Por favor, tente novamente.",
		user_rejected: "O usuário rejeitou a solicitação.",
		message_signature_denied: "Firma de mensagem negada",
		wallet_locked: "Por favor, desbloqueie sua extensão de carteira e tente novamente.",
		invalid_parameters: "Parâmetros inválidos. Por favor, tente novamente.",
		internal_error: "Ocorreu um erro interno. Por favor, tente novamente.",
		account_already_linked_to_different_profile: "Esta conta social já está vinculada a uma conta diferente.",
		connection_rejected: "Conexão rejeitada. Por favor, tente novamente.",
		missing_public_address: "Conexão cancelada. Por favor, tente novamente",
		connection_proposal_expired: "Proposta de conexão expirada. Por favor, tente novamente.",
		sei_not_enabled_in_keplr_wallet: "A rede Sei não está habilitada no Keplr. Por favor, habilite-a e tente novamente.",
	},
}

export default pt
